/* eslint-disable @typescript-eslint/no-explicit-any */
// ported from https://github.com/sindresorhus/p-is-promise/blob/master/index.js

const isObject = (value: any) =>
    value !== null &&
    (typeof value === "object" || typeof value === "function");

const isPromise = (value: any): value is Promise<unknown> => {
    return (
        value instanceof Promise ||
        (isObject(value) &&
            typeof value.then === "function" &&
            typeof value.catch === "function")
    );
};

export { isPromise };
